import {useEffect, useLayoutEffect, useRef, useState} from "react";
import classNames from "classnames";
import utilStyles from 'styles/utils.module.scss'


const CHUNK_SIZE = 10;

const Elem = (
    {
        children,
        idx,
        measure,
        renewIdxHeight,
        expectedHeight,
        transformsRef,
        currentIndicesRef,
        currentIndexElemsRef,
        colIndex,
        idxToHeightRef,
    }
) => {
    const elRef = useRef();

    useEffect(() => {
        if (idx in idxToHeightRef.current) {
            console.log('return')
            return;
        }
        const currentIndex = currentIndicesRef.current[colIndex];
        if (idx && currentIndex > idx) {
            if (!elRef.current) return;
            const realHeight = elRef.current.getBoundingClientRect().height;
            const heightDiff = expectedHeight - realHeight;
            transformsRef.current[colIndex] = transformsRef.current[colIndex] + heightDiff;
            renewIdxHeight(idx, realHeight);
            // measure();
        } else {
            window.requestAnimationFrame(() => {
                if (!elRef.current) return;
                const rect = elRef.current.getBoundingClientRect();
                const realHeight = rect.height;
                renewIdxHeight(idx, realHeight);
                // measure();
            });
        }
    }, []);

    if (idx === currentIndicesRef.current[colIndex]) {
        currentIndexElemsRef.current[colIndex] = elRef.current;
    }

    return (
        <div ref={elRef}>
            {children}
        </div>
    );
};

export const InfiniteScrollGrid = (props) => {
    const {
        remoteRowCount,
        expectedRowHeight,
        chunkSize,
        renderRow,
        fetchData,
        dataStorage,
        initialRow,
        topOffset,
        disabled,
        renderPlaceholder,
        scrollTargetId,
    } = props;
    const colCount = props.colCount || 1;
    const scrollTarget = scrollTargetId ? document.getElementById(scrollTargetId) : typeof window !== 'undefined' ? window : null;

    const _chunkSize = chunkSize || CHUNK_SIZE;
    const _topOffset = topOffset || 0;
    const idxToHeightRef = useRef({});
    const currentIndicesRef = useRef(Array.from(
        {length: colCount},
        e => 0,
    ));  // 여러개로 관리
    const currentIndexElemsRef = useRef(Array.from(
        {length: colCount},
        e => 0,
    ));  // 여러개로 관리
    const [applyChanges, setApplyChanges] = useState(Array.from(
        {length: colCount},
        e => false,
    ));  // 여러개로 관리
    const blockChangeRef = useRef(false);
    const startIndexRef = useRef(null);
    const endIndexRef = useRef(null);
    const prevVisibleIndicesRef = useRef(Array.from(
        {length: colCount},
        e => [],
    ));  // 여러개로 관리
    const remoteRowCountRef = useRef(remoteRowCount);
    const dataStorageRef = useRef(dataStorage);
    const disabledRef = useRef(disabled);

    const [visionInfo, setVisionInfo] = useState(
        Array.from(
            {length: colCount},
            e => {
                return {
                    upperHeight: expectedRowHeight * _chunkSize,
                    lowerHeight: 0,
                    visibleIndices: [],
                }
            }
        ),
    );  // 여러개로 관리

    const transformsRef = useRef(Array.from(
        {length: colCount},
        e => 0,
    ));  // 여러개로 관리

    const getScrollY = () => {
        if (scrollTarget === window) {
            return scrollTarget?.scrollY;
        } else {
            return scrollTarget?.scrollTop;
        }
    };

    useEffect(() => {
        remoteRowCountRef.current = remoteRowCount;
        console.log('remoteRowCountRef update', remoteRowCountRef.current);
        measure();
    }, [remoteRowCount]);

    useEffect(() => {
        disabledRef.current = disabled;
        if (!disabled) {
            console.log('disabled update', remoteRowCountRef.current);
            setTimeout(() => measure(), 500);
        }
    }, [disabled]);

    useEffect(() => {
        window.onbeforeunload = function () {
            scrollTarget?.scrollTo(0, 0);
        };

        return () => {
            window.onbeforeunload = null;
        };
    }, []);

    useEffect(() => {
        console.log('dataStorageRef update', dataStorage);
        dataStorageRef.current = dataStorage;
    }, [dataStorage]);

    const getRowHeight = (idx) => {
        if (idxToHeightRef.current[idx] === null || idxToHeightRef.current[idx] === undefined) return expectedRowHeight;
        return idxToHeightRef.current[idx];
    };

    const checkVisibleIndicesAndFetchData = (columnIndex) => {
        if (disabledRef.current) {
            return;
        }
        for (let i = 0; i < prevVisibleIndicesRef.current[columnIndex].length; i++) {
            const index = prevVisibleIndicesRef.current[columnIndex][i];
            if (!dataStorageRef.current[index] && (startIndexRef.current > index || endIndexRef.current <= index)) {
                const [_startIndex, _endIndex] = getChunk(index);
                startIndexRef.current = startIndexRef.current === null ? _startIndex : Math.min(startIndexRef.current, _startIndex);
                endIndexRef.current = endIndexRef.current === null ? _endIndex : Math.max(endIndexRef.current, _endIndex);
            }
        }
        if (startIndexRef.current === null || endIndexRef.current === null) return;
        fetchData(startIndexRef.current, endIndexRef.current);
    }

    const measureColumn = (columnIndex, lastVisionInfo = null, applyNow = false) => {
        if (!Boolean(lastVisionInfo)) {
            lastVisionInfo = visionInfo;
        }
        const currentScrollPos = getScrollY();
        console.log('measureColumn', columnIndex, remoteRowCountRef.current, disabledRef.current, currentScrollPos);
        if (disabledRef.current) {
            return;
        }


        const transform = transformsRef.current[columnIndex];
        // console.log(`currentScrollPos_${columnIndex}`, currentScrollPos);
        // console.log(`currentIdx_${columnIndex}`, currentIdx);

        let doCalculate = true;
        let changed = false;
        let res = [];
        let accHeight = 0;
        let upperHeight = 0;
        let lowerHeight = 0;
        while (doCalculate) {
            res = [];
            console.log('doCalculate', changed, currentScrollPos);
            accHeight = 0;
            upperHeight = 0;
            lowerHeight = 0;
            if (!blockChangeRef.current && currentScrollPos < expectedRowHeight) {
                currentIndicesRef.current[columnIndex] = 0;
            }
            const currentIdx = currentIndicesRef.current[columnIndex];
            doCalculate = false;
            for (let i = 0; i < remoteRowCountRef.current; i++) {
                if (i % colCount !== columnIndex) continue;
                const height = getRowHeight(i);
                if (i < currentIdx - _chunkSize) {
                    upperHeight += height;
                } else if (i >= currentIdx - _chunkSize && i <= currentIdx + _chunkSize) {
                    res.push(i);
                } else {
                    lowerHeight += height;
                }
                if (!blockChangeRef.current && (accHeight < currentScrollPos - transform && (
                    accHeight + height > currentScrollPos - transform || i + colCount > remoteRowCountRef.current - 1
                ))) {
                    if (!changed) {
                        currentIndicesRef.current[columnIndex] = i;
                        if (currentIdx !== i) {
                            doCalculate = true;
                            changed = true;
                            break;
                        }
                    }
                }
                accHeight += height;
            }
        }
        console.log(`res_${columnIndex}`, remoteRowCountRef.current, upperHeight, lowerHeight, res, accHeight, 'currentScrollPos', currentScrollPos, transform, columnIndex, currentIndicesRef.current[columnIndex], lastVisionInfo);

        const newVisionInfo = [...lastVisionInfo];
        newVisionInfo[columnIndex] = {
            upperHeight: upperHeight,
            lowerHeight: lowerHeight + transformsRef.current[columnIndex],
            visibleIndices: res,
        }
        if (applyNow) {
            setVisionInfo(newVisionInfo);
        }

        for (const idx of res) {
            if (!prevVisibleIndicesRef.current[columnIndex].includes(idx)) {
                prevVisibleIndicesRef.current[columnIndex] = JSON.parse(JSON.stringify(res));
                checkVisibleIndicesAndFetchData(columnIndex);
                break;
            }
        }
        return newVisionInfo;
    }

    const measure = () => {
        let newVisionInfo = visionInfo;
        for (let i = 0; i < colCount; i++) {
            newVisionInfo = measureColumn(i, newVisionInfo, false);
            if (newVisionInfo) {
                console.log('newVisionInfo', newVisionInfo, currentIndicesRef.current);
            }
        }
        if (newVisionInfo) {
            setVisionInfo(newVisionInfo);
        }
    };

    useLayoutEffect(() => {
        if (initialRow) {
            goToPost(initialRow);
        } else {
            measure();
        }
    }, []);

    const renewIdxHeight = (idx, height) => {
        idxToHeightRef.current[idx] = height;
    };


    const debounceRef = useRef(null);
    const debounceScrollPosCompensation = () => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            let maxOffset = transformsRef.current[0];
            for (let i = 0; i < colCount; i++) {
                const offset = transformsRef.current[i];
                if (maxOffset < offset) {
                    maxOffset = offset
                }
                transformsRef.current[i] = 0;
            }
            if (maxOffset !== 0) {
                scrollTarget?.scrollBy(0, -maxOffset);
            }
        }, 50);
    };

    const regularlyCompensateScrollPos = () => {
        setInterval(() => {
            if (disabledRef.current) {
                return;
            }
            let maxOffset = transformsRef.current[0];
            for (let i = 0; i < colCount; i++) {
                const offset = transformsRef.current[i];
                if (maxOffset < offset) {
                    maxOffset = offset
                }
                transformsRef.current[i] = 0;
            }
            if (maxOffset !== 0) {
                scrollTarget?.scrollBy(0, -maxOffset);
            }
        }, 200);
    };

    const lastMeasureScrollPos = useRef(0);
    // const scrollThrottleRef = useRef(null);
    const throttleOnScrollMeasure = () => {
        if (Math.abs(lastMeasureScrollPos.current - getScrollY()) < expectedRowHeight) return;
        console.log('throttleOnScrollMeasure', lastMeasureScrollPos.current, getScrollY());
        lastMeasureScrollPos.current = getScrollY();
        measure();
    };

    useEffect(() => {
        scrollTarget?.scrollTo(0, 0);
        regularlyCompensateScrollPos();
    }, []);

    useEffect(() => {
        const scrollHandler = () => {
            if (disabledRef.current) {
                return;
            }
            throttleOnScrollMeasure();
            // debounceScrollPosCompensation();
        }
        scrollTarget?.addEventListener('scroll', scrollHandler);
        return () => {
            scrollTarget?.removeEventListener('scroll', scrollHandler);
        }
    }, []);

    const goToPost = (idx) => {
        // const colIndex = idx % colCount;
        // console.log('goToPost', idx);
        // currentIndicesRef.current[colIndex] = idx;
        // blockChangeRef.current = true;
        // setApplyChanges(oldValues => {
        //     const newValues = [...oldValues];
        //     newValues[colIndex] = true;
        //     return newValues;
        // });
        // measure();
    };

    const throttleRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (disabledRef.current) {
                return;
            }
            blockChangeRef.current = true;
            if (throttleRef.current) clearTimeout(throttleRef.current);
            throttleRef.current = setTimeout(() => {
                blockChangeRef.current = false;
            }, 50);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(throttleRef.current);
        }
    }, []);

    // for (let i = 0; i<colCount; i++) {
    //     useEffect(() => {
    //         if (applyChanges[i] && currentIndexElemsRef.current[i]) {
    //             scrollTarget.scrollTo(0, currentIndexElemsRef.current[i].getBoundingClientRect().top - _topOffset);
    //             setApplyChanges(oldValues => {
    //                 const newValues = [...oldValues];
    //                 newValues[i] = false;
    //                 return newValues;
    //             });
    //             blockChangeRef.current = false;
    //         }
    //     }, [currentIndexElemsRef.current[i]]);
    // }

    const getChunk = (idx) => {
        const startIndex = Math.floor(idx / _chunkSize) * _chunkSize;
        const endIndex = startIndex + _chunkSize;
        return [startIndex, endIndex];
    };

    return (
        <div className={utilStyles.flexRow}
             style={{gap: 9}}
        >
            {
                [...Array(colCount).keys()].map(idx => {
                    return (
                        <div key={idx} style={{
                            flex: 1,
                            paddingTop: visionInfo[idx].upperHeight,
                            paddingBottom: visionInfo[idx].lowerHeight,
                            transform: `translateY(${transformsRef.current[idx]}px)`,
                            overflowAnchor: 'none'
                        }}>
                            {
                                visionInfo[idx].visibleIndices.map(e => {
                                    if (e % colCount !== idx) return;
                                    return (
                                        dataStorage[e]
                                            ?
                                            <Elem key={e} idx={e} currentIndicesRef={currentIndicesRef}
                                                  measure={() => measureColumn(idx, null, true)}
                                                  renewIdxHeight={renewIdxHeight} expectedHeight={getRowHeight(e)}
                                                  transformsRef={transformsRef}
                                                  currentIndexElemsRef={currentIndexElemsRef}
                                                  idxToHeightRef={idxToHeightRef}
                                                  colIndex={idx}
                                            >
                                                {renderRow(dataStorage[e], e)}
                                            </Elem>
                                            : renderPlaceholder(e)
                                    );
                                })
                            }
                        </div>
                    );
                })
            }
        </div>

    );

}
